export default {
  selectSize: 'Por favor, seleccione la especificación completa',
  inventory: 'Inventario',
  num: 'Cantidad',
  nimNumTips: 'Cantidad mínima de compra: {num}',
  addCart: 'Agregar al carrito',
  nowBuy: 'Comprar ahora',
  remark: 'Dejar un mensaje',
  goShop: 'ENTRAR A LA TIENDA',
  productTotalPrice: 'Precio total del producto',
  productDetail: 'Detalles del producto',
  sizeParams: 'Parámetros de especificación',
  shopNotes: 'Notas del agente de compras',
  saleService: 'Servicio postventa',
  productInfo: 'Información del producto',
  buyTips:
    'Los pedidos pagados entre las 09:00 y las 18:00 (hora de Beijing) se procesarán en 6 horas (excepto los domingos).',
  buyer: 'Vendedor',
  selfWarehouse: 'Almacén designado por acbuy',
  warehouse: 'Almacén designado por acbuy',
  yourAddress: 'Tu dirección',
  calcCountryFreight: 'Calcular el costo de envío internacional',
  holder: {
    remarkHolder:
      'Si tiene otras necesidades, deje un mensaje en los comentarios, el agente le ayudará a realizar la consulta.',
  },
  supportPayment: 'Métodos de pago disponibles',
  disclaimer:
    'Todos los productos disponibles para el servicio de agente de compras mostrados en acbuy provienen de plataformas de compra de terceros y no son vendidos directamente por acbuy. Por lo tanto, acbuy no asume responsabilidad ni responsabilidad legal por los problemas causados por la infracción de derechos de propiedad intelectual y la infracción de derechos de autor de los bienes.',
  readAgree: 'He leído y estoy de acuerdo con lo anterior',
  selectAgree: 'No estoy de acuerdo con el aviso legal',
  copyLink: 'Copiar enlace',
  copySuccess: 'Copia exitosa',
  disclaimer1: 'Aviso legal',
  editPrice: 'Editar precio',
  editPriceTips:
    'Tenga en cuenta que hay un problema con el canje de cupones. Recomendamos al usuario que cambie el precio de venta del artículo al precio original.',
  editPriceEnum: {
    0: 'Descuento de envío',
    1: 'Error de precio en la web',
    2: 'Negociado con el vendedor',
    3: 'Otra razón',
  },
  imgTranslation: 'Traducción de imágenes',
  translationTips: 'Haga clic en la imagen para traducir el texto',
  originTranslation: 'Original/Traducción',
  qcImg: 'Foto de control de calidad',
  deleteShopCollect: '¿Está seguro de que desea eliminar esta colección de la tienda?',
  inTransition: 'En transición...',
  originLink: 'Enlace original',
  singleProductData: 'Datos de un solo producto',
}
